import { Icon3d3d, Icon3dAlert, Icon3dCycle, Icon3dDetect, Icon3dLocation, Icon3dMeter } from '@assets/images/icon';
import { accessAutoThumb, deadboltThumb, emlockThumb } from '@assets/images/main/access/product';
import { IconAoaOff, IconAoaOn, IconComfortOff, IconComfortOn, IconOsOff, IconOsOn, IconTwintrackerOff, IconTwintrackerOn } from '@assets/images/main/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';
import {
  rtlsScreenshot1D,
  rtlsScreenshot1T,
  rtlsScreenshot1M,
  rtlsScreenshot2D,
  rtlsScreenshot2T,
  rtlsScreenshot2M,
  rtlsScreenshot3D,
  rtlsScreenshot3T,
  rtlsScreenshot3M,
  rtlsScreenshot4D,
  rtlsScreenshot4T,
  rtlsScreenshot4M,
  accessKey1,
  accessKey2,
  accessKey3,
  accessKey4,
  accessOutlook,
  IconBox,
  IconComputer,
  IconGuarantee,
  assetOn,
  workerOn,
  workerOff,
  IconPath,
  IconLocation,
  IconAnalyze,
  IconAlarm,
  IconExcel,
  IconSDK,
  assetOff,
} from '@assets/images/main/index';
import {
  RtlsFunctions1D,
  RtlsFunctions1M,
  RtlsFunctions1T,
  RtlsFunctions2D,
  RtlsFunctions2M,
  RtlsFunctions2T,
  RtlsFunctions3D,
  RtlsFunctions3M,
  RtlsFunctions3T,
  RtlsFunctions4D,
  RtlsFunctions4M,
  RtlsFunctions4T,
  RtlsFunctions5D,
  RtlsFunctions5M,
  RtlsFunctions5T,
} from '@assets/images/main/rtls/main/functions';
import {
  RtlsHardware1D,
  RtlsHardware1M,
  RtlsHardware1T,
  RtlsHardware2D,
  RtlsHardware2M,
  RtlsHardware2T,
  RtlsHardware3D,
  RtlsHardware3M,
  RtlsHardware3T,
  RtlsHardware4D,
  RtlsHardware4M,
  RtlsHardware4T,
} from '@assets/images/main/rtls/main/hardware';
import { assetTag, twinTracker1, twinTrackerBracket } from '@assets/images/main/rtls/product';
import {
  screenViewRtls1,
  screenViewRtls2,
  screenViewRtls3,
  screenViewRtls4,
  screenViewRtls5,
  screenViewRtls6,
  screenViewRtls7,
  screenViewRtls8,
} from '@assets/images/main/screenView';
import { ReactComponent as SvgScope } from '@assets/images/icon/svg/scope.svg';
import { ReactComponent as SvgBuildingLine } from '@assets/images/icon/svg/building-line.svg';
import { ReactComponent as SvgTopology } from '@assets/images/icon/svg/topology.svg';
import { ReactComponent as SvgZoneLine } from '@assets/images/icon/svg/zone-line.svg';
import { ReactComponent as SvgSunLine } from '@assets/images/icon/svg/sun-line.svg';
import { ReactComponent as SvgRoute } from '@assets/images/icon/svg/route.svg';
import { ReactComponent as SvgTagsLine } from '@assets/images/icon/svg/tags-line.svg';
import { ReactComponent as Svg3DLine } from '@assets/images/icon/svg/3d-line.svg';

export default {
  banner: {
    title: '室内定位追踪<br/>更简单。更准确。',
    desc: '从固定式到便携式，<br/>体验可在无限空间应用的高精度定位追踪技术。',
    schemeTitle: '选择适合您的定位方案',
    schemeDesc: '需要帮助做出决定吗？',
    schemeDesc2: '请联系我们',
    phone: '1522-9928',

    card: [
      {
        title: '仅限韩国',
        desc: '用于位置跟踪<br/>制造网络设备',
      },
      {
        title: '超过50亿条记录',
        desc: '亚洲最大规模的<br/>实时位置数据',
      },
      {
        title: '世界一流性能',
        desc: '使用AI算法<br/>具有最高水平的位置精度',
      },
    ],
  },

  mainPage: {
    product: {
      title: '了解产品组合',
      desc: '了解创新的定位产品组合。',
      asset: {
        title: '蓝牙BLE定位追踪',
        desc: '将BLE标签设备附着到您要监视或追踪的对象，实现实时位置追踪。',
      },
      worker: {
        title: '高精度UWB定位追踪',
        desc: '将UWB标签设备附着到您要监视或追踪的对象，实现实时位置追踪。',
      },
    },
  },
  screenView: {
    title: '通过精准定位连接资产与空间',
    data: [
      { icon: SvgScope, text: '实时位置追踪', img: screenViewRtls1 },
      { icon: SvgBuildingLine, text: '大规模资产管理', img: screenViewRtls2 },
      { icon: SvgTopology, text: '网络状态查看', img: screenViewRtls3 },
      { icon: SvgZoneLine, text: '区域管理', img: screenViewRtls4 },
      { icon: SvgSunLine, text: '热力图空间分析', img: screenViewRtls5 },
      { icon: SvgRoute, text: '通过移动路径分析', img: screenViewRtls6 },
      { icon: SvgTagsLine, text: '标签设备管理', img: screenViewRtls7 },
      { icon: Svg3DLine, text: '提供3D查看器', img: screenViewRtls8 },
    ],
  },
  screenShot: [
    {
      title: '将整个现场呈现在地图上',
      desc: '基于 BLE/UWB/AoA 的位置信息实时显示在建筑图纸和区域地图上。<br/>支持楼层查看、区域筛选和状态图标，实现可视化管理。',
      img: {
        desktop: rtlsScreenshot1D,
        tablet: rtlsScreenshot1T,
        mobile: rtlsScreenshot1M,
      },
    },
    {
      title: '像播放现在一样回放过去的轨迹',
      desc: '可以基于时间轴记录并回放人员或资产的移动历史。<br/>可选择特定时间段，对单个或多个对象的轨迹进行比较，或回顾异常情况。',
      img: {
        desktop: rtlsScreenshot2D,
        tablet: rtlsScreenshot2T,
        mobile: rtlsScreenshot2M,
      },
    },
    {
      title: '一眼看出最频繁移动的区域',
      desc: '提供以时间段为基础的移动量可视化热力图功能。<br/>可用于分析人员密集区域、低效路线、闲置空间，并优化布局或人员配置。',
      img: {
        desktop: rtlsScreenshot3D,
        tablet: rtlsScreenshot3T,
        mobile: rtlsScreenshot3M,
      },
    },
    {
      title: '进入指定区域，系统立即响应',
      desc: '在 ORBRO OS 中，可以在地图上直接定义所需区域（Zone）。<br/>当指定人员或资产进入或离开该区域时，系统将立即发出通知。<br/>这些通知事件也可通过 API 提供，方便与外部系统灵活对接。',
      img: {
        desktop: rtlsScreenshot4D,
        tablet: rtlsScreenshot4T,
        mobile: rtlsScreenshot4M,
      },
    },
  ],
  video: {
    title: 'ORBRO开始定位系统',
    desc: [
      { text: '通过仪表板功能，<br/>可快速确认设备状态标签终端的变动变化类别分类现状、区域现状。' },
      { text: '可通过设备快速确定目标位置和当前状态。<br/>提供准确的数据和简单的接口。' },
      { text: '可快速设置作业空间至危险区域，可快速掌握<br/>各区域的现状。' },
      { text: '包括进入危险区域在内，<br/>可快速发送适合各种情况的警报。' },
    ],
  },

  functions: {
    title: '创新的位置跟踪系统体验',
    desc: 'Orbro的位置跟踪系统通过提供基于Web的管理和移动应用程序，为用户提供最佳体验。通过这一方式，您可以在现有的位置跟踪系统中体验到最高级别的用户便利性。',

    line: 2,
    card: [
      {
        size: '3',
        tag: '集成管理软件',
        title: '基于室内地图的软件',
        label: '管理员',
        img: {
          desktop: RtlsFunctions1D,
          tablet: RtlsFunctions1T,
          mobile: RtlsFunctions1M,
        },
      },
      {
        size: '1',
        tag: '提供移动应用',
        title: '通过移动应用进行位置跟踪',
        label: '通用提供',
        img: {
          desktop: RtlsFunctions2D,
          tablet: RtlsFunctions2T,
          mobile: RtlsFunctions2M,
        },
      },
      {
        size: '2',
        tag: '设备历史管理',
        title: '按区域实时记录设备位置',
        label: '管理员',
        img: {
          desktop: RtlsFunctions3D,
          tablet: RtlsFunctions3T,
          mobile: RtlsFunctions3M,
        },
      },
      {
        size: '2',
        tag: '区域设置',
        title: '按区域实时跟踪设备',
        label: '管理员',
        img: {
          desktop: RtlsFunctions4D,
          tablet: RtlsFunctions4T,
          mobile: RtlsFunctions4M,
        },
      },
      {
        size: '2',
        tag: '设备管理',
        title: '便捷的设备管理',
        label: '管理员',
        img: {
          desktop: RtlsFunctions5D,
          tablet: RtlsFunctions5T,
          mobile: RtlsFunctions5M,
        },
      },
    ],
  },

  hardware: {
    title: '核心是硬件，一切都轻松创新。',
    desc: '我们的位置追踪系统设备是经过特殊设计的设备，考虑了定向天线和现场环境。应用定向天线以实现最佳性能和稳定性，可在各种情况下有效运行。',
    card: [
      {
        img: {
          desktop: RtlsHardware1D,
          tablet: RtlsHardware1T,
          mobile: RtlsHardware1M,
        },
        tag: '定向天线',
        title: '使用定向天线进行准确的位置追踪',
        desc: 'TwinTracker（位置追踪设备）的定向天线可以推断出无线信号的方向。',
      },
      {
        img: {
          desktop: RtlsHardware2D,
          tablet: RtlsHardware2T,
          mobile: RtlsHardware2M,
        },
        tag: '各种支架',
        title: '天花板嵌入式，可安装射灯',
        falldown: [
          {
            title: '天花板嵌入式支架',
            desc: '可以安装在各种天花板上，<br/>包括石膏、tex、SMC、Myton等。',
          },
          {
            title: '轨道式支架',
            desc: '与照明使用的轨道规格相同，<br/>如果天花板上已经安装了轨道，随时可以安装。',
          },
        ],
      },
      {
        img: {
          desktop: RtlsHardware3D,
          tablet: RtlsHardware3T,
          mobile: RtlsHardware3M,
        },
        tag: '创新技术',
        title: '使用TDoA技术的最小安装，最大性能',
        desc: 'TDoA技术是一种在保持高性能通信的同时创新性地降低电池消耗的通信技术。它在实时运行的同时，记录的位置精度远高于传统方法。',
      },
      {
        img: {
          desktop: RtlsHardware4D,
          tablet: RtlsHardware4T,
          mobile: RtlsHardware4M,
        },
        tag: '多种通信方式',
        title: '有线通信，无线通信，均可连接',
      },
    ],
  },

  faqRequest: '欢迎随时咨询',
  faqRequestTail: '我们。',
  FAQ: [
    {
      title: '我不懂技术，也能使用吗？',
      description: 'ORBRO 系统提供简单但强大的界面，即使没有任何技术知识也能轻松使用。<br/>通过可视化数据实现直观操作和分析。',
    },
    {
      title: '定位精度有多高？',
      description: 'ORBRO 的 RTLS 系统非常精准，<br/>可以实现几乎零误差、极低延迟的数据同步。',
    },
    {
      title: '只能定位吗？我还想要其他功能。',
      description: 'ORBRO 技术具备高度扩展性。<br/>除了定位，还可应用于路线分析、越界警报、禁区管理等多种用途。',
    },
    {
      title: 'ORBRO 定位系统是如何工作的？',
      description: 'ORBRO 利用 BLE、UWB、AoA 等无线技术，由标签发出信号，锚点接收并计算位置。<br/>实时位置数据会显示在 ORBRO OS 地图界面或手机应用上。',
    },
    {
      title: 'TwinTracker BLE、UWB、AoA 有什么区别？',
      description: 'BLE：低功耗、易安装、1–3 米精度<br/>UWB：高精度（10–30cm）、响应快、适合复杂环境<br/>AoA：基于 BLE 信号角度定位，适合室内精细路线分析',
    },
    {
      title: 'Comfort Kit 能与 ORBRO 一起使用吗？',
      description: 'Comfort Kit 是独立使用的移动设备，无需 ORBRO OS 或服务器。<br/>可通过手机 App 实时查看位置，适用于无服务器环境。',
    },
    {
      title: 'ORBRO OS 适用于哪些环境？',
      description: 'ORBRO OS 适用于安装了 ORBRO Server 或 Edge 的环境中。<br/>支持定位、事件监控、历史分析等功能，<br/>地图界面直观，便于管理员和运营者使用。',
    },
    {
      title: '定位数据可以用于其他系统吗？',
      description: '可以。ORBRO 提供 API 接口，<br/>可与外部系统（如智能工厂平台、安全系统等）集成使用。',
    },
    {
      title: '同一现场可以同时使用多个设备吗？',
      description: '当然可以。<br/>支持 BLE、UWB、AoA 设备混合部署，<br/>打造适合复杂环境的混合解决方案。',
    },
    {
      title: '能否实现室内外定位？',
      description: '可以。室内使用 BLE/UWB/AoA，<br/>室外与 GPS 集成形成混合定位系统。',
    },
    {
      title: '系统最多能同时管理多少个 Tag？',
      description: '根据系统设计和服务器性能，从几十个到几千个均可。<br/>ORBRO 能够稳定支持大规模追踪环境。',
    },
    {
      title: '安装和维护难吗？',
      description: 'ORBRO 提供从规划到施工、调试的全套支持。<br/>大多数设备支持远程监控和固件更新，<br/>维护工作仅需更换电池及定期检查。',
    },
    {
      title: '如何查看定位信息？',
      description: '可在 ORBRO OS 地图界面直观查看位置数据，<br/>手机 App 也可实时同步显示。<br/>此外也支持 API 接口供外部系统调用。',
    },
  ],

  bannerData: [
    {
      icon: IconTwintrackerOn,
      iconInv: IconTwintrackerOff,
      image: '',
      iconText: 'TwinTracker UWB',
      sub: 'New',
      link: '/cn/rtls/uwb',
    },
    {
      icon: IconAoaOn,
      iconInv: IconAoaOff,
      image: '',
      iconText: 'TwinTracker AoA',
      sub: 'New',
      link: '/cn/rtls/aoa',
    },
    {
      icon: IconTwintrackerOn,
      iconInv: IconTwintrackerOff,
      image: '',
      iconText: 'TwinTracker BLE',
      sub: 'New',
      link: '/cn/rtls/ble',
    },
    {
      icon: IconComfortOn,
      iconInv: IconComfortOff,
      image: '',
      iconText: 'Comfort Kit',
      sub: 'New',
      link: '/cn/rtls/comfort',
    },
  ],

  product: {
    asset: {
      func: '内置电池的产品，无需电源施工，只需贴在门旁边，即可通过手机轻松快速地控制门的进出。',
      key1: accessKey1,
      key2: accessKey2,
      key3: accessKey3,
      key4: accessKey4,
      outlook: accessOutlook,
    },
  },

  purchaseDesc: {
    asset: '将BLE标签设备附着到您要监视或追踪的对象，实现实时位置追踪。',
    worker: '将UWB标签设备附着到您要监视或追踪的对象，实现实时位置追踪。',
  },

  purchase: {
    //移动设备
    asset: {
      assetTracking: {
        icon: accessKey1,
        title: '资产定位',
        serial: 'Asset-Tracking',
        price: '5,900,000',

        note: [
          { text: 'TwinTracker (BLE) 10台', icon: IconBox },
          { text: '资产追踪标签 30个', icon: IconBox },
          { text: 'Server PC 1台', icon: IconComputer },
          { text: '3年保修期', icon: IconGuarantee },
        ],

        parts: [
          {
            title: '资产标签(BLE)',
            price: '30,000',
            img: assetTag,
          },
          {
            title: 'TwinTracker(BLE)',
            price: '300,000',
            img: twinTracker1,
          },
          {
            title: 'TwinTracker支架',
            price: '100,000',
            img: twinTrackerBracket,
          },
        ],
        mark: '',
      },
    },

    //自动门进出
    worker: {
      workerTracking: {
        icon: accessKey1,
        title: '员工定位',
        serial: 'Worker-Tracking',
        price: '5,000,000',

        note: [
          { text: 'TwinTracker (UWB) 10台', icon: IconBox },
          { text: '员工追踪标签 10个', icon: IconBox },
          { text: 'Server PC 1台', icon: IconComputer },
          { text: '3年保修期', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Tag(UWB)',
            price: '60,000',
            img: emlockThumb,
          },
          {
            title: 'TwinTracker(UWB)',
            price: '300,000',
            img: deadboltThumb,
          },
          {
            title: 'TwinTracker支架',
            price: '100,000',
            img: accessAutoThumb,
          },
        ],
        mark: '',
      },
    },
  },

  func: {
    title: '了解更多功能',
    desc: '探索定位追踪的多种功能。',

    data: [
      {
        img: IconBlueShield,
        title: '权限与分组管理',
        desc: '区分管理员和用户权限，按角色控制功能访问，并可按部门或团队进行分组管理。',
      },
      {
        img: IconAlarm,
        title: '条件警报设定（5级）',
        desc: '可根据设定条件配置五个等级的警报，快速检测异常并及时应对。',
      },
      {
        img: Icon3dMeter,
        title: '区域监控（Zone）',
        desc: '在地图上设置区域，实时监控人员或资产是否进入该区域。',
      },
      {
        img: Icon3dCycle,
        title: '逆行检测',
        desc: '系统会自动检测与预定路线相反方向的移动，并发出警告。',
      },
      {
        img: Icon3dLocation,
        title: '按类别管理追踪',
        desc: '可将标签设备分类为人员、资产、车辆等，实现高效的数据管理与统计分析。',
      },
      {
        img: Icon3dAlert,
        title: '持续未检测标签通知',
        desc: '若标签在设定时间内未被检测，系统会自动向管理员发送通知。',
      },
      {
        img: Icon3dDetect,
        title: '进出区域检测',
        desc: '自动检测进出特定区域，并支持出入记录和停留时间分析。',
      },
      {
        img: Icon3d3d,
        title: '设备搜索与状态管理',
        desc: '可快速搜索多个 Tag 和 Anchor 设备，并查看电量与连接状态。',
      },
    ],
  },
};
